import { Observable } from 'rxjs';

export abstract class IActionsService {
  public abstract getActions(establishmentId: string): Observable<any>;
}
